// Marketing book page. Placeholder — eventually embeds a Calendly /
// Cal.com / SavvyCal widget. For now, falls through to the existing
// external booking flow at seidrplatform.com/#book so links don't
// dead-end during the migration.

import React, { useEffect } from 'react';

const EXTERNAL_BOOK_URL = 'https://calendly.com/benjamin-respire/seidr';

export default function BookPage() {
  useEffect(() => {
    // Send the visitor to the existing external booking calendar.
    // Replace with an embedded widget once we pick a provider.
    window.location.replace(EXTERNAL_BOOK_URL);
  }, []);

  return (
    <main className="mx-auto max-w-prose px-6 py-24 text-center">
      <p className="text-ink/70">
        Redirecting to the booking calendar…{' '}
        <a className="text-teal underline" href={EXTERNAL_BOOK_URL}>
          continue manually
        </a>
        .
      </p>
    </main>
  );
}
